import stylesControllerMixin from '@/mixins/stylesControllerMixin'
import layoutMixin from '@/mixins/layoutMixin'

export default {
    mixins: [stylesControllerMixin, layoutMixin],

    computed: {
        visible() {
            return this.scene === 'landing' ? { opacity: 0 } : { opacity: 1 }
        },

        rotate() {
            return { rotate: rotationMap.get(this.scene) }
        },

        size() {
            return {
                scale: this.scene === 'overview' ? 0.5 : 1
            }
        },

        styles() {
            return ['visible', 'rotate']
        }
    }
}

const rotationMap = new Map([
    ['landing', 0],
    ['intro', 0],
    ['technology', 0],
    ['strategy', -120],
    ['culture', -240],
    ['prototype', -330],
    ['empowerment', -450],
    ['innovation', -570],
    ['overview', 0]
])
